import { firmarConAutoFirmaAxios } from "../components/services/AutofirmaService";
import { AutoScript } from "../resources/js/autoscript";

function descargarAutomaticamenteBase64Pdf(signatureB64, nombreArchivo = "documento_firmado.pdf") {
    const byteCharacters = atob(signatureB64);
    const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = nombreArchivo;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click(); // 🔁 DESCARGA AUTOMÁTICA
    document.body.removeChild(a);

    // Limpieza opcional
    URL.revokeObjectURL(url);
}


export function cargarAutoFirma() {
    AutoScript.cargarAppAfirma()
}

export function firmar(coordenadas,pdfB64, onSuccess) {
  

  if (!pdfB64 || typeof pdfB64 !== "string") {
    alert("No se proporcionó un PDF válido para firmar.");
    return;
  }

  const {
    x1 = 60,
    y1 = 370,
    x2 = 500,
    y2 = 420,
    page = 1
  } = coordenadas || {};

  const config = `
    signaturePositionOnPageLowerLeftX=${x1}
    signaturePositionOnPageLowerLeftY=${y1}
    signaturePositionOnPageUpperRightX=${x2}
    signaturePositionOnPageUpperRightY=${y2}
    signaturePages=${page}
  `.trim();

  AutoScript.sign(
    pdfB64,
    "SHA256withRSA",
    "Adobe PDF",
    config,
    (signatureB64, certificateB64, extraData) => {
      
      if (onSuccess && typeof onSuccess === "function") {
        onSuccess(signatureB64);
      }
    },
    (errorType, errorMessage) => {
      // console.error("Error al firmar:", errorType, errorMessage);
      firmaErrorCallback(errorType, errorMessage);
    }
  );
}



export function firmaCorrectaCallback(signatureB64, certificateB64, extraData) {
   
    showLog("Firma OK");
    if (extraData) {
        // var extras = JSON.parse(extraData);
        
    }

    // Mostramos el certificado Base 64
    //showLog("Certificado:\n" + certificateB64);

    // A modo ilustrativo, mostramos la firma Base 64 en el formulario
    // document.getElementById('result').value = signatureB64;

    // // Agregamos la firma a un campo oculto para enviarla junto al formulario
    // document.getElementById('resultField').value = signatureB64;

    alert("pdf firmado b64: ", signatureB64)
    return signatureB64
}
export function firmaErrorCallback(errorType, errorMessage) {
    // console.error("Error Type: " + errorType + "\\nMessage: " + errorMessage);
    // Show user-friendly alert for known errors
    if (errorType === "java.lang.Exception" && errorMessage && errorMessage.includes("SAF_28")) {
        alert("Error: El fichero no es un PDF o es un PDF no soportado. Por favor, verifique el archivo.");
    } else if (errorType === "es.gob.afirma.standalone.ApplicationNotFoundException") {
        alert("Error: No se pudo conectar con AutoFirma. Asegúrese de que la aplicación esté instalada y en ejecución.");
    } else {
        alert("Se produjo un error durante la firma: " + errorMessage);
    }
    // Additional logging for debugging
    
}

export function showLog(newLog) {
    alert(newLog);
}

export function peticionFirma(pdfB64){
    const extraParamsBase64 = "c2lnbmF0dXJlUmVhc29uPUZpcm1hIGNv..."; // tu cadena completa en base64

firmarConAutoFirmaAxios(
    pdfB64,
    extraParamsBase64,
    (firmaBase64) => {
        descargarAutomaticamenteBase64Pdf(firmaBase64, "documento_firmado_visible.pdf");
    },
    (err) => {
        alert("No se pudo firmar el documento");
    }
);
}